import React from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Page from "../layout/page";
import styles from "./ErrorPage.module.scss";

/**
 * Shared animated card layout for error / status pages (boundary crash, 404, 500).
 */
export default function ErrorPageLayout({
    icon,
    variant = "warning",
    pageTitle,
    headTitle,
    heading,
    message,
    actions,
}) {
    return (
        <Page showsSearchBar title={pageTitle} headTitle={headTitle}>
            <div className={styles.wrapper}>
                <div className={styles.card}>
                    <div className={classNames(styles.iconBadge, styles[variant])}>
                        <FontAwesomeIcon icon={icon} />
                    </div>

                    <h1 className={styles.heading}>{heading}</h1>

                    {message && <p className={styles.subtext}>{message}</p>}

                    {actions && <div className={styles.actions}>{actions}</div>}
                </div>
            </div>
        </Page>
    );
}
